import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import getPropertyRows from "./PropertyByAddress";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class Properties extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    let rows = [];
    let recCount = 0;
    rows.push(
      <Table.Row
        key={`prop_sub_head_title`}
        className={"report-sub-section-header"}
      >
        <Table.Cell colSpan={2}>
          Property Records Associated with Subject
        </Table.Cell>
      </Table.Row>
    );
    if (props.reportData) {
      const properties = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].properties[0].property"
      );
      rows = this.processProperties(props, properties, rows, 1, 0);
      recCount = rows.length;
      if (!properties) {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    rows.push(
      <Table.Row
        key={`prop_sub_head_by_Add_title`}
        className={"report-sub-section-header"}
      >
        <Table.Cell colSpan={2}>Property Records by Address</Table.Cell>
      </Table.Row>
    );
    let propRowsByAddress = [];
    propRowsByAddress = this.processReportAddresses(
      props,
      "personReport.compReportResponse[0].individual[0].bpsReportAddresses[0].bpsReportAddress",
      propRowsByAddress
    );
    if (propRowsByAddress.length === 0) {
      rows.push(
        <Table.Row key={`no_recs_prop_by_address_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    } else {
      rows = rows.concat(propRowsByAddress);
      recCount += propRowsByAddress.length;
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  processReportAddresses = (props, nodePath, rows) => {
    if (props.reportData) {
      const addressList = _.get(props.reportData, nodePath);
      if (addressList !== undefined) {
        _.forEach(addressList, (address, addIndex) => {
          const properties = _.get(address, "properties[0].property");
          rows = this.processProperties(props, properties, rows, addIndex, 1);
        });
      }
    }
    return rows;
  };

  processProperties = (props, properties, rows, addIndex, type) => {
    if (properties !== undefined) {
      _.forEach(properties, (property, propsIndex) => {
        rows = rows.concat(
          getPropertyRows(props, property, addIndex, propsIndex, type)
        );
      });
    }
    return rows;
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Property Records"}
        rows={this.state.rows}
      />
    );
  }
}

export default Properties;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/Properties.js